import dynamic from 'next/dynamic';
import { FC } from 'react';
import { AdditionalDetailsProps } from './AdditionalDetails';

//@TODO: This should've been moved on per app basis
//And the component itself should be pure UI without lazy loading logic
const AdditionalDetailsComponent = dynamic(
  () => import('./AdditionalDetails').then((module) => module.AdditionalDetails),
  {
    ssr: false,
  }
) as FC<AdditionalDetailsProps>;

// Extend this array in a proper order if some of the additional details are missing
const keys = [
  'What happens on the day?',
  'Participant guidelines',
  'Availability',
  'How long should I allow for this experience?',
  'Can I bring spectators?',
  'Additional information',
  'What about insurance?',
  'How it works',
  'Packaging and Delivery',
  'Delivery Guidelines',
  'Medical guidelines',
  'How do I make my reservation?',
  'Dress code',
  'Event information',
  'Essential Information',
  'What Locations are there?',
];

export const AdditionalDetails = ({ texts, isPreviousVisible }) => {
  if (!texts?.length) return null;

  const items = keys
    .map((key) => texts.find(({ name }) => name.toLowerCase() === key.toLowerCase()))
    // filter out empty objects
    .filter((obj) => obj?.content);

  return isPreviousVisible ? (
    <AdditionalDetailsComponent additionalDetails={items} id="additional-details" />
  ) : (
    // Placeholder to keep DOM structure until intersection observer is trigerred
    <div className="hidden" id="additional-details">
      {items.map(({ name, content }) => (
        <div key={name}>
          <h2>{name}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </div>
      ))}
    </div>
  );
};
